import { isSvpCategory } from '../modules/helpers';

import type { SvpAssetAdditional } from '@vgtv/api-client/lib/svp_asset';
import type { SvpCategoryAdditional } from '@vgtv/api-client/lib/svp_category';

export type FavouriteType = 'asset' | 'category';

export type FavouriteId = `${FavouriteType}:${number}`;

export const mapItemToType = (
  item: SvpAssetAdditional | SvpCategoryAdditional
) => {
  return isSvpCategory(item) ? 'category' : 'asset';
};

export const createFavouriteId = (
  item: SvpAssetAdditional | SvpCategoryAdditional
): FavouriteId => {
  return `${mapItemToType(item)}:${item.id}`;
};
